import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { Column } from '../api/api';
import KanbanTaskCard from './KanbanTaskCard';
import './BoardColumn.css';

interface BoardColumnProps {
  column: Column;
  onAddTask: () => void;
  onDeleteColumn: () => void;
  onEditColumn?: () => void;
  onTaskUpdate: () => void;
  canDelete?: boolean;
  dragHandleProps?: any;
}

const BoardColumn: React.FC<BoardColumnProps> = ({
  column,
  onAddTask,
  onDeleteColumn,
  onEditColumn,
  onTaskUpdate,
  canDelete = false,
  dragHandleProps,
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id: column.id.toString(),
    data: {
      columnId: column.id.toString(),
    },
  });

  return (
    <div 
      ref={setNodeRef}
      className={`board-column ${isOver ? 'drag-over' : ''}`}
      data-column-id={column.id}
      style={{ position: 'relative' }}
    >
      <div className="column-header">
        <h3 
          {...dragHandleProps}
          className={dragHandleProps ? 'column-drag-handle' : ''}
          style={dragHandleProps ? { cursor: 'grab' } : {}}
        >
          {column.name}
        </h3>
        {canDelete && (
        <div className="column-actions">
          {onEditColumn && (
            <button
              onClick={onEditColumn}
              className="edit-column-btn"
              title="Переименовать столбец"
            >
              ✎
            </button>
          )}
          <button
            onClick={onDeleteColumn}
            className="close-btn delete-column-btn"
            title="Удалить столбец"
          >
            ×
          </button>
        </div>
        )}
      </div>
      <div className="column-tasks">
        {column.tasks?.map((task) => (
          <KanbanTaskCard
            key={task.id}
            task={task}
            onUpdate={onTaskUpdate}
            columnName={column.name}
          />
        ))}
      </div>
      <button onClick={onAddTask} className="add-task-btn">
        + Добавить задачу
      </button>
    </div>
  );
};

export default BoardColumn;

